import React from 'react'



export default function Pricing() {
  return <>

    <section id="pricing" className='py-5 about-section'>

    
    <div  className="container">
      <h3 className='text-center py-5'>Pricing</h3>
      <div className="row">
        <div className="col-md-12 text-white">
        <table class="table table-hover">
  <thead>
    <tr>
      <th scope="col">vCPU</th>
      <th scope="col">Memory</th>
      <th scope="col">Storage</th>
      <th scope="col">Monthly Price</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">2</th>
      <td>2 GB</td>
      <td>65 GB</td>
      <td>7$</td>
    </tr>
    <tr>
      <th scope="row">2</th>
      <td>4 GB</td>
      <td>80 GB</td>
      <td>13$</td>
    </tr>
    <tr>
    <th scope="row">4</th>
      <td>8 GB</td>
      <td>160 GB</td>
      <td>21$</td>
    </tr>
    <tr>
    <th scope="row">6</th>
      <td>16 GB</td>
      <td>320 GB</td>
      <td>35$</td>
    </tr>
    <tr>
    <th scope="row">8</th>
      <td>32 GB</td>
      <td>640 GB</td>
      <td>70$</td>
    </tr>
  </tbody>
</table>
        </div>
      </div>

    </div>
    <div  className="container">
      <h3 className='text-center py-5'>Farm / Bots Virtual Machine Pricing (Vsro)</h3>
      <div className="row">
        <div className="col-md-12 text-white">
        <table class="table table-hover">
  <thead>
    <tr>
      <th scope="col">vCPU</th>
      <th scope="col">Memory</th>
      <th scope="col">Storage</th>
      <th scope="col">Monthly Price</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">2</th>
      <td>2 GB</td>
      <td>65 GB</td>
      <td>4$</td>
    </tr>
    <tr>
      <th scope="row">2</th>
      <td>4 GB</td>
      <td>80 GB</td>
      <td>9$</td>
    </tr>
    <tr>
    <th scope="row">4</th>
      <td>8 GB</td>
      <td>160 GB</td>
      <td>16$</td>
    </tr>
    <tr>
    <th scope="row">6</th>
      <td>16 GB</td>
      <td>320 GB</td>
      <td>25$</td>
    </tr>
  </tbody>
</table>
        </div>
      </div>

    </div>
    <div className='text-center text-muted py-5'>
      <li className='py-2'>Feel free to contact us via Discord, and we will respond as promptly as possible.</li>
      <li className='py-2'>We accept all payment methods, ensuring convenience for customers worldwide.</li>
      <li className='py-2'>Take advantage of our special offer: when you purchase multiple VPSs, you will receive a generous discount.</li>
      <li className='py-2'>After completing the payment process, you will receive your VPS information via email or Discord. after 1 hour working time.</li>
      <li className='py-2'>Experience the reliability of our virtual machines firsthand with our complimentary 1-hour testing service.</li>
      <li className='py-2'>Our virtual machines support all private servers, ensuring compatibility with your preferred gaming environment.</li>
      <li className='py-2'>Feel free to contact me if you face any problems in setup , bots , scripts or any problem in the virtual machine environment</li>
    </div>
  
    </section>
  
  </>
}
 